import type { FaireProductEntity } from "../../entity_types/product";

export const p_k23tx4c6vs: FaireProductEntity = {
  token: "p_k23tx4c6vs",
  type: "product",
  name: "Cough Syrup",
  brandToken: "b_c96vrxm17w",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/53b63ae2d29329642176c72a0e941194cd1bdee861a08a9c23378474a1b57f75.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27ead17d2e0c5742d0cae049409b9248fcba032cdd662bb73c4e855f6d7e8a9a.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "SOOTHE + RELIEVE COUGH REMEDY\n\nFormulated to soothe, boost and settle your cough symptoms. A natural gentle and effective cough remedy.\n\nPro tip : Best paired with Elderberry Syrup and Salty(throat gargle)\n\nFOR CHILDREN 1 & UP\n\nTO USE: Shake well. Adults take 1-2 tablespoons every 4 hours or as needed. Children take 1-2 teaspoons every 4 hours",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:56.876Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
